import { render } from "./AgeGrade.vue?vue&type=template&id=3b5b1787"
import script from "./AgeGrade.vue?vue&type=script&lang=js"
export * from "./AgeGrade.vue?vue&type=script&lang=js"

import "./AgeGrade.vue?vue&type=style&index=0&id=3b5b1787&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__